"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Question_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Question = void 0;
const dcterms_1 = require("lincd-dcmi/lib/ontologies/dcterms");
const rdf_1 = require("lincd-rdf/lib/ontologies/rdf");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const titan_ads_1 = require("../ontologies/titan-ads");
const package_1 = require("../package");
let Question = Question_1 = class Question extends Shape_1.Shape {
    static loadAll() {
        return Server_1.Server.call(package_1.packageName, 'loadAll', Question_1.shape.namedNode);
    }
    static fromQuoraResponse(question) {
        const URI = process.env.DATA_ROOT + '/' + encodeURIComponent(question.qid);
        const questionNode = models_1.NamedNode.getOrCreate(URI);
        questionNode.overwrite(rdf_1.rdf.type, titan_ads_1.titanAds.Question);
        const newQuestion = new Question_1(questionNode);
        if (newQuestion.name)
            return newQuestion;
        newQuestion.name = JSON.parse(question.question.title).sections[0].spans[0].text;
        newQuestion.id = question.qid;
        newQuestion.weeklyViewsLb = question.weeklyViewsLowerBound;
        newQuestion.weeklyViewsUb = question.weeklyViewsUpperBound;
        return newQuestion;
    }
    get id() {
        return Number.parseInt(this.getValue(dcterms_1.dcterms.identifier));
    }
    set id(val) {
        this.overwrite(dcterms_1.dcterms.identifier, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get name() {
        return this.getValue(dcterms_1.dcterms.title);
    }
    set name(val) {
        this.overwrite(dcterms_1.dcterms.title, new models_1.Literal(val));
    }
    get weeklyViewsLb() {
        return Number.parseInt(this.getValue(titan_ads_1.titanAds.viewsLowerBound));
    }
    set weeklyViewsLb(val) {
        this.overwrite(titan_ads_1.titanAds.viewsLowerBound, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get weeklyViewsUb() {
        return Number.parseInt(this.getValue(titan_ads_1.titanAds.viewsUpperBound));
    }
    set weeklyViewsUb(val) {
        this.overwrite(titan_ads_1.titanAds.viewsUpperBound, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
};
exports.Question = Question;
Question.targetClass = titan_ads_1.titanAds.Question;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.identifier,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Question.prototype, "id", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.title,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Question.prototype, "name", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.viewsLowerBound,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Question.prototype, "weeklyViewsLb", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.viewsUpperBound,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Question.prototype, "weeklyViewsUb", null);
exports.Question = Question = Question_1 = __decorate([
    package_1.linkedShape
], Question);
//# sourceMappingURL=Question.js.map